import {
  GET_SHORTLIST_MANAGERS_DATA_LIST,
  GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS,
  GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED,
  GET_INTERVIEWERS_LIST,
  GET_INTERVIEWERS_LIST_SUCCESS,
  GET_INTERVIEWERS_LIST_FAILED,
  ADD_SHORTLIST_MANAGER_M,
  ADD_INTERVIEWER_M,
  UPDATE_SHORTLIST_MANAGER,
  UPDATE_INTERVIEWER_M,
} from "./actionTypes";

export const getShortListManagersList = (data) => {
  return {
    type: GET_SHORTLIST_MANAGERS_DATA_LIST,
    payload: data,
  };
};

export const getShortListManagersListSuccess = (data) => {
  return {
    type: GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS,
    payload: data,
  };
};

export const getShortListManagersListFailed = (data) => {
  return {
    type: GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED,
    payload: data,
  };
};

export const getInterviewersList = (data) => {
  return {
    type: GET_INTERVIEWERS_LIST,
    payload: data,
  };
};

export const getInterviewersListSuccess = (data) => {
  return {
    type: GET_INTERVIEWERS_LIST_SUCCESS,
    payload: data,
  };
};

export const getInterviewersListFailed = (data) => {
  return {
    type: GET_INTERVIEWERS_LIST_FAILED,
    payload: data,
  };
};

export const addShorlistManager = (data) => {
  return {
    type: ADD_SHORTLIST_MANAGER_M,
    payload: data,
  };
};

export const updateShorlistManager = (data) => {
  return {
    type: UPDATE_SHORTLIST_MANAGER,
    payload: data,
  };
};

export const addInterviewer = (data) => {
  return {
    type: ADD_INTERVIEWER_M,
    payload: data,
  };
};

export const updateInterviewer = (data) => {
  return {
    type: UPDATE_INTERVIEWER_M,
    payload: data,
  };
};
